/* =====================================================================
   The Italian Chocolate 1971 · cart page behaviour (/cart)       v1.1 · 2026-10-16
   Theme: Monochrome 1.2.2. DRAFT theme 207315370327 only.
   Loaded (defer) by sections/tic-cart-page.liquid. Vanilla JS, no dependencies.

   The theme's cart.js stays in charge of quantity and remove requests (<cart-items>,
   POST /cart/change with the Section Rendering API, it refreshes .js-contents and
   .js-contents-2). This file only adds what cart.js lacks, and never sends a second
   request for the same change:
   1. After each cart.js update (its `cart:change` event carries the whole response, sections
      included): refreshes the page's other parts ([data-tic-cp-region]: heading + count,
      suggestions, sticky subtotal), animates the free-shipping bar from the old value
      (same recipe as tic-cart.js in the drawer), settles the numbers, lets the remaining
      lines slide into place after a removal (FLIP) and shows "Removed … Undo",
      announces the result in one polite live region, moves focus sensibly, shows
      "You can only add N" and turns errors into a message on the line. A Remove pressed while
      a quantity change is still pending waits for it (cart.js sends lines by number).
   2. "Add" in the suggestions and "Undo": POST /cart/add.js with this section's id,
      replaces the same containers without a reload, fires `cart:change`.
      Without JavaScript both are plain forms / links.
   3. Gift message: the order note, saved through /cart/update.js 600ms after typing stops, on
      blur and when the page is hidden or left (keepalive); the field also belongs to form#cart,
      so it always travels with the checkout. Hidden when nothing ships.
   4. Checkout: busy state, no double submit; phone/tablet sticky bar that proxies the
      real button (so Meety's "disabled" on button#checkout also blocks it).
   5. Safety: the theme's <cart-items> reloads ITSELF from ?section_id=main-cart on any
      `cart-update` pub/sub event from another source, which would empty this page; that
      subscription is replaced by a full refresh of this section. Same refresh when the
      page comes back from the back/forward cache or another script changes the cart.
   Never publishes a pub/sub `cart-update`; never touches the cart drawer.
   ===================================================================== */
(function () {
  'use strict';
  if (window.__ticCartPage) return; // included twice: keep a single instance
  window.__ticCartPage = true;

  var ROOT_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var mqBar = window.matchMedia ? window.matchMedia('(max-width: 1023px)') : null;
  var OWN = 'tic-cart-page'; // sectionId used in the cart:change events this file dispatches
  var MSG = {
    error: 'Your cart could not be updated. Please try again.',
    addError: 'This box could not be added. Please try again.',
    undoError: 'This box could not be added back. Please try again.',
    noteError: 'Your message could not be saved. Please try again.',
    noteSaved: 'Gift message saved.',
    cap: 'You can only add [n] of this item to your cart.',
    empty: 'Your cart is empty.'
  };
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };

  var root = null;
  var sectionId = '';
  var pending = null;      // the change cart.js is about to send: { type, line, title, at, … }
  var held = [];           // keys of lines whose Remove waits for the pending cart.js change
  var stepPress = null;    // the last +/- pressed: { line, name, at } (Safari/iOS do not focus it)
  var blurred = null;      // the element cart.js blurred when its request started
  var refocusLine = 0;     // Enter in a quantity field: give focus back to that line
  var lastInput = 'pointer';
  var subscribed = false;
  var refreshTimer = null;
  var sayTimer = null;
  var checkoutBusy = false;
  var busyTimer = null;
  var noteFlush = null;
  var cta = null;
  var bar = null;
  var proxy = null;
  var ctaVisible = true;
  var fieldFocus = false;
  var barIo = null;
  var ctaMo = null;
  var walletRo = null;
  var noteTimer = null;
  var noteSeq = 0;
  var noteSavedTimer = null;

  /* ---------- helpers ---------- */
  function reduced() { return !!(mqReduce && mqReduce.matches); }
  function $(sel, ctx) { return (ctx || root || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root || document).querySelectorAll(sel)); }
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function txt(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function clamp01(n) { return n < 0 ? 0 : n > 1 ? 1 : n; }
  function json(s) { try { return JSON.parse(s || '{}') || {}; } catch (e) { return {}; } }
  function isField(el) {
    return !!(el && el.matches && el.matches('input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="button"]), textarea, select'));
  }
  function isEmptyCart() {
    var ci = $('cart-items');
    return !!(ci && ci.classList.contains('is-empty'));
  }
  function focusLost() {
    var ae = document.activeElement;
    return !ae || ae === document.body || ae === document.documentElement;
  }
  function rowByKey(key) {
    if (!key) return null;
    var rows = $$('.tic-cp-line[data-key]');
    for (var i = 0; i < rows.length; i++) if (rows[i].getAttribute('data-key') === key) return rows[i];
    return null;
  }
  // a cart.js change is waiting for its debounce or its response (stale after 10s: never block for good)
  function cartJsBusy() {
    return !!(pending && Date.now() - (pending.at || 0) < 10000);
  }

  document.addEventListener('keydown', function (e) {
    if (!e.metaKey && !e.ctrlKey && !e.altKey) lastInput = 'key';
  }, true);
  document.addEventListener('pointerdown', function () { lastInput = 'pointer'; }, true);

  /* ---------- one polite live region for the whole page ---------- */
  function say(message) {
    var live = $('[data-tic-cp-live]');
    if (!live || !message) return;
    clearTimeout(sayTimer);
    live.textContent = '';
    // a short pause so the same sentence twice in a row is still announced
    sayTimer = setTimeout(function () { live.textContent = message; }, 120);
  }

  /* ---------- reading the state before a re-render ---------- */
  function readShip() {
    var el = $('[data-tic-ship]');
    if (!el) return null;
    var msgA = el.querySelector('[data-tic-msg-a]');
    return {
      fill: clamp01(parseFloat(el.getAttribute('data-fill')) || 0),
      unlocked: el.getAttribute('data-unlocked') === 'true',
      msg: msgA ? msgA.innerHTML : ''
    };
  }
  function snapshotRows() {
    var map = {};
    $$('.tic-cp-line[data-key]').forEach(function (row) {
      map[row.getAttribute('data-key')] = row.getBoundingClientRect().top;
    });
    return map;
  }

  /* ---------- free-shipping bar: previous state -> new state (tic-cart.js recipe) ---------- */
  function animateShip(prev) {
    var el = $('[data-tic-ship]');
    if (!el || !prev || reduced()) return;
    var fillEl = el.querySelector('.tic-ship__fill');
    var msgA = el.querySelector('[data-tic-msg-a]');
    var fill = clamp01(parseFloat(el.getAttribute('data-fill')) || 0);
    var unlocked = el.getAttribute('data-unlocked') === 'true';
    if (!fillEl || (prev.fill === fill && prev.unlocked === unlocked)) return;
    // unlocking: the "You're X away" line fades out with the words it had a moment ago
    if (unlocked && !prev.unlocked && msgA && prev.msg && !msgA.innerHTML.trim()) msgA.innerHTML = prev.msg;
    el.classList.add('is-instant');
    el.classList.toggle('is-unlocked', prev.unlocked);
    fillEl.style.transform = 'scaleX(' + prev.fill + ')';
    void fillEl.getBoundingClientRect(); // commit the previous state
    el.classList.remove('is-instant');
    el.style.setProperty('--tic-delay', '0ms');
    el.style.setProperty('--tic-delay-icon', unlocked && !prev.unlocked ? '150ms' : '0ms');
    requestAnimationFrame(function () {
      el.classList.toggle('is-unlocked', unlocked);
      fillEl.style.transform = 'scaleX(' + fill + ')';
    });
  }

  /* ---------- remaining lines slide into place (no height animation) ---------- */
  function flip(before) {
    if (!before || reduced()) return;
    $$('.tic-cp-line[data-key]').forEach(function (row) {
      var top = before[row.getAttribute('data-key')];
      if (typeof top !== 'number') return;
      var dy = top - row.getBoundingClientRect().top;
      if (Math.abs(dy) < 1) return;
      row.style.transition = 'none';
      row.style.transform = 'translateY(' + dy + 'px)';
      void row.getBoundingClientRect();
      row.style.transition = 'transform 240ms cubic-bezier(0.23, 1, 0.32, 1)';
      row.style.transform = '';
      var done = function (e) {
        if (e.target !== row || e.propertyName !== 'transform') return;
        row.style.transition = '';
        row.removeEventListener('transitionend', done);
      };
      row.addEventListener('transitionend', done);
    });
  }

  /* ---------- numbers come back from .45 to 1 once the server's values are in ---------- */
  function settle(line) {
    if (!root) return;
    var row = line ? document.getElementById('CartItem-' + line) : null;
    if (row && root.contains(row)) row.setAttribute('aria-busy', 'true');
    root.classList.add('is-updating', 'is-settling');
    void root.getBoundingClientRect();
    root.classList.remove('is-settling', 'is-updating');
    $$('.tic-cp-line[aria-busy]').forEach(function (r) { r.removeAttribute('aria-busy'); });
  }

  /* ---------- "Removed … Undo" in the slot of the removed line ---------- */
  function insertRemoved(act) {
    var list = $('[data-tic-cp-list]');
    if (!list) return null;
    var li = document.createElement('li');
    li.className = 'tic-cp-removed';
    var p = document.createElement('p');
    p.className = 'tic-cp-removed__text';
    p.appendChild(document.createTextNode('Removed '));
    var name = document.createElement('span');
    name.className = 'notranslate';
    name.setAttribute('translate', 'no');
    name.textContent = act.title;
    p.appendChild(name);
    p.appendChild(document.createTextNode('.'));
    li.appendChild(p);
    var ctl;
    if (act.booking) {
      // a booking cannot be put back as it was (Meety holds the slot): choose again
      ctl = document.createElement('a');
      ctl.className = 'tic-cp-removed__undo';
      ctl.href = root.getAttribute('data-tasting-url') || (ROOT_URL + 'pages/atelier-tasting-experience');
      ctl.textContent = 'Book again';
    } else {
      ctl = document.createElement('button');
      ctl.type = 'button';
      ctl.className = 'tic-cp-removed__undo';
      ctl.setAttribute('data-tic-cp-undo', '');
      ctl.setAttribute('aria-label', 'Undo: add ' + act.title + ' back to your cart');
      ctl.innerHTML = '<span class="tic-cp-removed__undo-label">Undo</span><span class="tic-cp-spin" aria-hidden="true"></span>';
      ctl.__ticUndo = act;
    }
    li.appendChild(ctl);
    var ref = document.getElementById('CartItem-' + act.line);
    if (ref && ref.parentNode === list) list.insertBefore(li, ref);
    else list.appendChild(li);
    return ctl;
  }

  /* ---------- refresh the parts cart.js does not know about ---------- */
  function applyRegions(doc) {
    $$('[data-tic-cp-region]').forEach(function (live) {
      var key = live.getAttribute('data-tic-cp-region');
      var fresh = doc.querySelector('[data-tic-cp-region="' + key + '"]');
      if (fresh) live.innerHTML = fresh.innerHTML;
    });
    // "does anything ship": the gift message (outside the refreshed containers) follows it
    var freshRoot = doc.querySelector('[data-tic-cp]');
    if (root && freshRoot && freshRoot.hasAttribute('data-ships')) root.setAttribute('data-ships', freshRoot.getAttribute('data-ships'));
  }

  function setEmpty(empty) {
    if (!root) return;
    var was = root.classList.contains('tic-cp--empty');
    root.classList.toggle('tic-cp--empty', empty);
    root.setAttribute('data-empty', empty ? 'true' : 'false');
    var ci = $('cart-items');
    if (ci) ci.classList.toggle('is-empty', empty);
    var foot = document.getElementById('main-cart-footer');
    if (foot) foot.classList.toggle('is-empty', empty);
    var c = document.getElementById('checkout');
    if (c) {
      // only undo a "disabled" this page set itself (Meety may disable it for an expired booking)
      if (empty) {
        if (!c.disabled) {
          c.disabled = true;
          c.setAttribute('data-tic-cp-empty-off', '');
        }
      } else if (c.hasAttribute('data-tic-cp-empty-off')) {
        c.disabled = false;
        c.removeAttribute('data-tic-cp-empty-off');
      }
    }
    if (empty && !was) {
      var block = $('[data-tic-cp-empty]');
      if (block) {
        block.classList.remove('is-entering');
        void block.getBoundingClientRect();
        block.classList.add('is-entering');
      }
    }
    syncBar();
  }

  function updateBubble(html, count) {
    if (!html) return;
    var ok = false;
    if (typeof window.mergeCartIconBubbleFromSectionHtml === 'function') {
      ok = window.mergeCartIconBubbleFromSectionHtml(html, '.shopify-section');
    } else {
      var link = document.getElementById('cart-icon-bubble');
      var fresh = parse(html).querySelector('.cart-count-bubble');
      var old = link && link.querySelector('.cart-count-bubble');
      if (fresh && old) {
        old.outerHTML = fresh.outerHTML;
        ok = true;
      }
    }
    if (ok && typeof count === 'number') {
      var l = document.getElementById('cart-icon-bubble');
      if (l) l.classList.toggle('header__cart--empt', count < 1);
    }
  }

  // Our own renders (add, undo, refresh): the same containers cart.js replaces, plus ours.
  function renderAll(sections, prev, count) {
    var html = sections && sections[sectionId];
    if (!html || !root) return false;
    var doc = parse(html);
    var pairs = [
      ['#main-cart-items .js-contents', '.js-contents'],
      ['#main-cart-footer .js-contents-2', '.js-contents-2']
    ];
    pairs.forEach(function (p) {
      var live = document.querySelector(p[0]);
      var fresh = doc.querySelector(p[1]);
      if (live && fresh) live.innerHTML = fresh.innerHTML;
    });
    applyRegions(doc);
    var freshRoot = doc.querySelector('[data-tic-cp]');
    setEmpty(freshRoot ? freshRoot.getAttribute('data-empty') === 'true' : isEmptyCart());
    if (sections['cart-icon-bubble']) updateBubble(sections['cart-icon-bubble'], count);
    animateShip(prev);
    return true;
  }

  function refreshAll() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      if (!root || !document.contains(root)) return;
      var prev = readShip();
      var url = ROOT_URL + 'cart?sections=' + encodeURIComponent(sectionId) + ',cart-icon-bubble';
      fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error(String(r.status));
          return r.json();
        })
        .then(function (sections) {
          if (renderAll(sections, prev)) settle(null);
        })
        .catch(function () { /* keep the page as it is; the next change re-renders it */ });
    }, 200);
  }

  /* ---------- messages ---------- */
  function lineErrorBox(line) {
    return document.querySelector('#Line-item-error-' + line + ' .cart-item__error-text');
  }
  function clearGlobalError() {
    var g = document.getElementById('cart-errors');
    if (g) g.textContent = '';
  }
  function shipPhrase() {
    var el = $('[data-tic-ship]');
    if (!el) return '';
    if (el.getAttribute('data-unlocked') === 'true') return 'Free EU shipping unlocked.';
    var a = txt(el.querySelector('[data-tic-msg-a]'));
    return a ? a + '.' : '';
  }
  function announce(act, empty) {
    if (empty) {
      say(MSG.empty);
      return;
    }
    var parts = [];
    if (act && act.type === 'remove') parts.push('Removed ' + act.title + '.');
    else if (act && act.type === 'qty') {
      var input = document.getElementById('Quantity-' + act.line);
      parts.push(act.title + ': quantity ' + (input ? input.value : act.requested) + '.');
    } else if (act && act.type === 'add') parts.push('Added ' + act.title + '.');
    else if (act && act.type === 'undo') parts.push(act.title + ' is back in your cart.');
    var sub = txt($('[data-tic-cp-subtotal]'));
    if (sub) parts.push('Subtotal ' + sub + '.');
    if (!act || act.type !== 'remove') {
      var s = shipPhrase();
      if (s) parts.push(s);
    }
    say(parts.join(' '));
  }
  function checkCap(act, cart) {
    // Shopify can lower a quantity (stock); cart.js only says so when every line has .cart-item
    if (!act || act.type !== 'qty' || !cart || !cart.items) return;
    var item = cart.items[act.line - 1];
    if (!item || String(item.variant_id) !== String(act.variantId)) return;
    if (item.quantity >= act.requested) return;
    var box = lineErrorBox(act.line);
    if (box) box.textContent = MSG.cap.replace('[n]', item.quantity);
  }

  // cart.js blurs the focused element when its request starts; it gives focus back only to an
  // element with the same name that the browser had focused (Safari and iOS never focus a tapped
  // button). Give back what it blurred if it is still on the page (the gift message, say).
  function takeBlurred() {
    var b = blurred;
    blurred = null;
    return b && b !== document.body && document.contains(b) && !b.disabled ? b : null;
  }

  function focusAfter(act, empty, undoCtl) {
    var lost = focusLost();
    var back = takeBlurred();
    var fromField = refocusLine > 0;
    var line = refocusLine || (act && act.line);
    refocusLine = 0;
    if (empty) {
      if (act || lost) {
        var h = $('[data-tic-cp-h1]');
        if (h) h.focus();
      }
      return;
    }
    if (undoCtl) {
      undoCtl.focus({ preventScroll: true });
      return;
    }
    if (!lost) return;
    if (back) {
      back.focus({ preventScroll: true });
      return;
    }
    if (!line) return;
    var row = document.getElementById('CartItem-' + line) || $('.tic-cp-line');
    if (!row) return;
    var target = null;
    if (fromField || (lastInput === 'key' && !(act && act.control))) {
      // Enter, or a value typed and committed from the keyboard: back to the field
      target = row.querySelector('input[name="updates[]"]:not([type="hidden"])') || row.querySelector('.tic-cp-line__title');
    } else if (act && act.control) {
      // +/- pressed: back to the same button (no ring after a pointer press, the bar stays)
      target = row.querySelector('button[name="' + act.control + '"]');
    }
    // a value committed by clicking elsewhere: focus stays where the pointer put it
    if (target) target.focus({ preventScroll: true });
  }

  // after a failed request nothing was re-rendered: the blurred control, else the line's control
  function focusAfterError(act) {
    var back = takeBlurred();
    if (!focusLost()) return;
    if (back) {
      back.focus({ preventScroll: true });
      return;
    }
    var row = act && act.line ? document.getElementById('CartItem-' + act.line) : null;
    if (!row) return;
    var target = (act.control && row.querySelector('button[name="' + act.control + '"]')) ||
      (act.type === 'remove' && row.querySelector('cart-remove-button a')) ||
      row.querySelector('.tic-cp-line__title');
    if (target) target.focus({ preventScroll: true });
  }

  // a Remove pressed while a quantity change was pending runs now, found by its key
  // (line numbers shift after a removal; a quantity change does not move them)
  function releaseHeld() {
    if (!held.length) return;
    setTimeout(function () { // after cart.js's own finally (loading state cleared)
      while (held.length && !cartJsBusy()) {
        var row = rowByKey(held.shift());
        var link = row && row.querySelector('cart-remove-button a');
        if (link) link.click(); // through onClickCapture again: the next one waits for this one
      }
    }, 0);
  }

  /* ---------- 1. after every cart.js update ---------- */
  function afterCartJs(cart, before) {
    if (!root || !document.contains(root)) return;
    var act = pending;
    pending = null;
    var html = cart.sections && cart.sections[sectionId];
    if (html) applyRegions(parse(html));
    else refreshAll();
    var empty = cart.item_count === 0;
    setEmpty(empty);
    animateShip(before.ship);
    var undoCtl = null;
    if (act && act.type === 'remove') {
      // cart.js compares the number of .cart-item rows (Meety bookings only, on this page) with the
      // number of lines; after a removal that test means nothing, so a message it wrote on a line
      // ("You can only add …" on the row that moved up) is dropped. It ran synchronously before this.
      $$('#main-cart-items .cart-item__error-text').forEach(function (b) { b.textContent = ''; });
      if (!empty) {
        undoCtl = insertRemoved(act);
        flip(before.rows);
      }
    }
    checkCap(act, cart);
    settle(act && act.type === 'qty' ? act.line : null);
    clearGlobalError();
    focusAfter(act, empty, undoCtl);
    announce(act, empty);
    syncBar();
    releaseHeld();
  }

  document.addEventListener('cart:change', function (e) {
    if (!root || !document.contains(root)) return;
    var d = (e && e.detail) || {};
    if (d.sectionId === OWN) return; // dispatched by this file after its own render
    if (d.sectionId === sectionId && d.cart) {
      // cart.js dispatches this right BEFORE it swaps the containers: read the old state now,
      // finish once its whole update (swap, live region, focus) has run
      var before = { ship: readShip(), rows: snapshotRows() };
      Promise.resolve().then(function () { afterCartJs(d.cart, before); });
      return;
    }
    refreshAll(); // another script changed the cart
  });

  document.addEventListener('cart:error', function (e) {
    if (!root || !document.contains(root)) return;
    var d = (e && e.detail) || {};
    if (d.source && d.source !== sectionId) return;
    var act = pending;
    pending = null;
    root.classList.remove('is-updating');
    $$('.tic-cp-line.is-leaving').forEach(function (r) { r.classList.remove('is-leaving'); });
    $$('.tic-cp-line[aria-busy]').forEach(function (r) { r.removeAttribute('aria-busy'); });
    var generic = window.cartStrings && window.cartStrings.error;
    var msg = typeof d.message === 'string' && d.message && d.message !== generic ? d.message : MSG.error;
    if (act && act.line) {
      var input = document.getElementById('Quantity-' + act.line);
      if (input) {
        input.value = input.getAttribute('value'); // back to what the server has
        syncMinus(input);
      }
      var box = lineErrorBox(act.line);
      if (box) {
        box.textContent = msg; // role="alert" on the line
        clearGlobalError();    // one announcement, next to the line
      }
    }
    if (!act || !act.line || !lineErrorBox(act.line)) {
      var g = document.getElementById('cart-errors');
      if (g) g.textContent = msg;
    }
    focusAfterError(act);
    releaseHeld();
  });

  document.addEventListener('cart:refresh', function () { if (root) refreshAll(); });

  /* ---------- recording what cart.js is about to send ---------- */
  function syncMinus(input) {
    var q = input && input.closest('quantity-input');
    var m = q && q.querySelector('button[name="minus"]');
    if (!m) return;
    var v = parseInt(input.value, 10);
    if (v > 1) m.removeAttribute('aria-disabled');
    else m.setAttribute('aria-disabled', 'true');
  }

  function onChangeCapture(e) {
    var input = e.target;
    if (!input || input.name !== 'updates[]' || !input.hasAttribute('data-index')) return;
    syncMinus(input);
    var v = parseInt(input.value, 10);
    if (!isNaN(v) && String(v) === input.getAttribute('value') && !pending) {
      e.stopPropagation(); // same quantity as the server: no request, no re-render
      return;
    }
    var row = input.closest('.tic-cp-line');
    var line = Number(input.getAttribute('data-index'));
    var press = stepPress && stepPress.line === line && Date.now() - stepPress.at < 1000 ? stepPress : null;
    stepPress = null;
    pending = {
      type: 'qty',
      line: line,
      requested: isNaN(v) ? 1 : v,
      variantId: row ? row.getAttribute('data-variant-id') : '',
      title: row ? row.getAttribute('data-title') : '',
      control: press ? press.name : '', // '+' / '-' button that made this change, if any
      at: Date.now()
    };
    var box = lineErrorBox(pending.line);
    if (box) box.textContent = '';
    if (row) row.setAttribute('aria-busy', 'true');
    root.classList.add('is-updating');
  }

  function onClickCapture(e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var step = t.closest('.tic-cp-step .quantity__button');
    if (step && root.contains(step)) {
      // the theme turns this click into a change right after: remember which button it was
      var sr = step.closest('.tic-cp-line');
      stepPress = { line: sr ? Number(sr.getAttribute('data-index')) : 0, name: step.getAttribute('name'), at: Date.now() };
      return;
    }
    var rm = t.closest('cart-remove-button');
    if (!rm || !root.contains(rm)) return;
    var row = rm.closest('.tic-cp-line');
    if (!row) return;
    if (row.classList.contains('is-leaving')) {
      // already on its way out: no second request
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    if (cartJsBusy()) {
      // a change is still waiting for cart.js (its 300ms debounce) or for its response: it carries a
      // line number that would point to another product once this line is gone. The removal waits
      // and runs as soon as that change is done (releaseHeld).
      e.preventDefault();
      e.stopPropagation();
      var key = row.getAttribute('data-key');
      if (key && held.indexOf(key) === -1) held.push(key);
      return;
    }
    pending = {
      type: 'remove',
      line: Number(rm.getAttribute('data-index')),
      key: row.getAttribute('data-key'),
      title: row.getAttribute('data-title') || '',
      variantId: Number(row.getAttribute('data-variant-id')),
      quantity: Number(row.getAttribute('data-quantity')) || 1,
      properties: json(row.getAttribute('data-properties')),
      sellingPlan: row.getAttribute('data-selling-plan') || '',
      booking: row.hasAttribute('data-booking'),
      at: Date.now()
    };
    row.classList.add('is-leaving');
    root.classList.add('is-updating');
  }

  function onKeydown(e) {
    // Enter in a quantity field would submit form#cart with its first button: checkout.
    // It commits the field instead (blur fires the browser's own change, so cart.js sends
    // exactly one request); focus comes back to the same field after the update.
    if (e.key !== 'Enter') return;
    var t = e.target;
    if (!t || t.name !== 'updates[]' || !t.hasAttribute('data-index')) return;
    e.preventDefault();
    if (t.value === t.getAttribute('value')) return;
    refocusLine = Number(t.getAttribute('data-index'));
    t.blur();
  }

  /* ---------- 2. "Add" (suggestions) and "Undo" without reloading the page ---------- */
  function addVariant(payload, btn, kind, title) {
    if (!payload || !payload.id || !btn || btn.getAttribute('aria-busy') === 'true') return;
    var card = btn.closest('.tic-cp-sug');
    var errBox = card ? card.querySelector('[data-tic-cp-error]') : null;
    if (errBox) {
      errBox.hidden = true;
      errBox.textContent = '';
    }
    var viaKey = lastInput === 'key';
    var prev = readShip();
    btn.setAttribute('aria-busy', 'true');
    btn.setAttribute('aria-disabled', 'true');
    root.classList.add('is-updating');
    fetch(ROOT_URL + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: JSON_HEADERS,
      body: JSON.stringify({ items: [payload], sections: [sectionId, 'cart-icon-bubble'], sections_url: window.location.pathname })
    })
      .then(function (r) {
        return r.json().then(function (body) { return { ok: r.ok, body: body }; });
      })
      .then(function (res) {
        if (!res.ok || !res.body || res.body.status) {
          var err = new Error('add');
          err.userMessage = res.body && (res.body.description || res.body.message);
          throw err;
        }
        var addedKey = res.body.items && res.body.items[0] && res.body.items[0].key;
        if (!renderAll(res.body.sections, prev)) {
          refreshAll();
        } else {
          settle(null);
        }
        clearGlobalError();
        announce({ type: kind, title: title }, false);
        // the button is gone with the old list: continue from the line just added (also after a
        // tap or a screen reader's click, which would otherwise leave focus on <body>)
        if (viaKey || focusLost()) {
          var row = rowByKey(addedKey);
          var target = (row && row.querySelector('.tic-cp-line__title')) || $('[data-tic-cp-h1]');
          if (target) {
            if (viaKey) target.focus();
            else target.focus({ preventScroll: true });
          }
        }
        return fetch(ROOT_URL + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var l = document.getElementById('cart-icon-bubble');
            if (l && cart && typeof cart.item_count === 'number') l.classList.toggle('header__cart--empt', cart.item_count < 1);
            document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: cart, sectionId: OWN } }));
          })
          .catch(function () { /* the page is already up to date */ });
      })
      .catch(function (err) {
        root.classList.remove('is-updating');
        if (!document.contains(btn)) return;
        btn.removeAttribute('aria-busy');
        btn.removeAttribute('aria-disabled');
        var m = (err && err.userMessage) || (kind === 'undo' ? MSG.undoError : MSG.addError);
        if (errBox) {
          errBox.textContent = m;
          errBox.hidden = false;
        } else {
          var host = btn.closest('.tic-cp-removed');
          var out = host && host.querySelector('[data-tic-cp-error]');
          if (host && !out) {
            out = document.createElement('p');
            out.className = 'tic-cp-sug__error';
            out.setAttribute('role', 'alert');
            out.setAttribute('data-tic-cp-error', '');
            host.appendChild(out);
          }
          if (out) out.textContent = m;
          else {
            var g = document.getElementById('cart-errors');
            if (g) g.textContent = m;
          }
        }
      });
  }

  function onSubmitCapture(e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-tic-cp-add-form]')) return;
    var btn = form.querySelector('[data-tic-cp-add]');
    if (!btn) return; // plain POST /cart/add (the shop returns to /cart)
    e.preventDefault();
    addVariant({ id: Number(btn.getAttribute('data-tic-cp-add')), quantity: 1 }, btn, 'add', btn.getAttribute('data-title') || '');
  }

  function onUndoClick(e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-tic-cp-undo]') : null;
    if (!btn || !root.contains(btn) || !btn.__ticUndo) return;
    e.preventDefault();
    var a = btn.__ticUndo;
    var payload = { id: a.variantId, quantity: a.quantity };
    if (a.properties && Object.keys(a.properties).length) payload.properties = a.properties;
    if (a.sellingPlan) payload.selling_plan = Number(a.sellingPlan);
    addVariant(payload, btn, 'undo', a.title);
  }

  /* ---------- 3. gift message (order note) ---------- */
  function setupNote() {
    var area = $('[data-tic-cp-note]');
    if (!area || area.__ticNote) return;
    area.__ticNote = true;
    var gift = area.closest('[data-tic-cp-gift]');
    var toggle = gift && gift.querySelector('summary');
    var count = $('[data-tic-cp-note-count]');
    var live = $('[data-tic-cp-note-live]');
    var errBox = $('[data-tic-cp-note-error]');
    var max = Number(area.getAttribute('maxlength')) || 250;
    var lastSaved = area.value;
    var savingValue = null;     // the value of the save in flight
    var typedSinceFocus = false;
    var userToggle = false;

    function updateCount() {
      if (count) count.textContent = area.value.length + '/' + max;
    }
    function sayNoteSaved() {
      if (!live) return;
      live.textContent = '';
      setTimeout(function () { live.textContent = MSG.noteSaved; }, 60);
    }
    function needsSave() {
      return !!noteTimer || (savingValue === null ? area.value !== lastSaved : area.value !== savingValue);
    }
    function save() {
      clearTimeout(noteTimer);
      noteTimer = null;
      var value = area.value;
      if (value === savingValue || (savingValue === null && value === lastSaved)) {
        if (savingValue === null) gift.classList.remove('is-saving');
        return;
      }
      var seq = ++noteSeq;
      savingValue = value;
      gift.classList.add('is-saving');
      gift.classList.remove('is-saved');
      fetch(ROOT_URL + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: JSON_HEADERS,
        body: JSON.stringify({ note: value }),
        keepalive: true // still sent when the shopper leaves the page right after typing
      })
        .then(function (r) {
          if (!r.ok) throw new Error(String(r.status));
          return r.json();
        })
        .then(function () {
          if (seq !== noteSeq) return; // a newer save is on its way
          savingValue = null;
          lastSaved = value;
          gift.classList.remove('is-saving');
          gift.classList.add('is-saved');
          if (errBox) errBox.textContent = '';
          // read out once the shopper has left the field, not after every pause while typing
          if (document.activeElement !== area) sayNoteSaved();
          clearTimeout(noteSavedTimer);
          noteSavedTimer = setTimeout(function () { gift.classList.remove('is-saved'); }, 2000);
        })
        .catch(function () {
          if (seq !== noteSeq) return;
          savingValue = null;
          gift.classList.remove('is-saving');
          if (errBox) errBox.textContent = MSG.noteError;
        });
    }
    // leaving the page (link, Back, app switch) within the 600ms pause: send it now
    noteFlush = function () {
      if (!checkoutBusy && document.contains(area) && needsSave()) save();
    };

    area.addEventListener('input', function () {
      updateCount();
      typedSinceFocus = true;
      gift.classList.remove('is-saved');
      clearTimeout(noteTimer);
      noteTimer = setTimeout(save, 600);
    });
    area.addEventListener('focus', function () { typedSinceFocus = false; });
    area.addEventListener('blur', function () {
      if (needsSave()) save();
      else if (typedSinceFocus && savingValue === null) sayNoteSaved(); // saved while typing: say it once
      typedSinceFocus = false;
    });
    if (toggle) {
      toggle.addEventListener('click', function () { userToggle = true; });
      toggle.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') userToggle = true; });
    }
    // contents fade and rise 4px when the shopper opens it (never on page load)
    gift.addEventListener('toggle', function () {
      if (!userToggle) return;
      userToggle = false;
      if (!gift.open) return;
      gift.classList.remove('is-anim');
      void gift.getBoundingClientRect();
      gift.classList.add('is-anim');
      area.focus({ preventScroll: true });
    });
    gift.addEventListener('animationend', function () { gift.classList.remove('is-anim'); });
  }

  /* ---------- 4. checkout: busy state, one submit; sticky bar ---------- */
  function resetCheckout() {
    checkoutBusy = false;
    clearTimeout(busyTimer);
    busyTimer = null;
    if (cta) cta.removeAttribute('aria-busy');
    if (proxy) proxy.removeAttribute('aria-busy');
  }

  function setupCheckout() {
    var form = document.getElementById('cart');
    cta = document.getElementById('checkout');
    if (!form || form.__ticCheckout) return;
    form.__ticCheckout = true;
    form.addEventListener('submit', function (e) {
      var s = e.submitter;
      if (s && s.name !== 'checkout') return;
      if (checkoutBusy) {
        e.preventDefault();
        return;
      }
      // busy only once every listener has run and none cancelled the submit
      setTimeout(function () {
        if (e.defaultPrevented || checkoutBusy) return;
        checkoutBusy = true;
        // the note field belongs to this form: it travels with the checkout, no wait needed
        clearTimeout(noteTimer);
        noteTimer = null;
        if (cta) cta.setAttribute('aria-busy', 'true');
        if (proxy) proxy.setAttribute('aria-busy', 'true');
        // a navigation stopped by the shopper (Esc) or a dead network must not leave it stuck
        clearTimeout(busyTimer);
        busyTimer = setTimeout(resetCheckout, 8000);
      }, 0);
    });
  }

  function syncBar() {
    if (!bar || bar.hidden) return;
    var on = !!(mqBar && mqBar.matches) && !isEmptyCart();
    document.documentElement.classList.toggle('tic-cp-bar-on', on);
    bar.classList.toggle('is-shown', on && !ctaVisible && !fieldFocus);
  }

  function setupBar() {
    bar = $('[data-tic-cp-bar]');
    proxy = bar ? bar.querySelector('[data-tic-cp-proxy]') : null;
    cta = document.getElementById('checkout');
    if (!bar || !proxy || !cta || !mqBar || !('IntersectionObserver' in window)) return;
    bar.hidden = false;
    if (barIo) barIo.disconnect();
    ctaVisible = true;
    barIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { ctaVisible = en.isIntersecting; });
      syncBar();
    }, { rootMargin: '0px 0px -88px 0px' });
    barIo.observe(cta);
    proxy.addEventListener('click', function () {
      if (cta.disabled) {
        cta.scrollIntoView({ block: 'center', behavior: reduced() ? 'auto' : 'smooth' });
        return;
      }
      cta.click(); // the real button: Meety's checks and the form submit stay in one place
    });
    var mirror = function () {
      if (cta.disabled) proxy.setAttribute('aria-disabled', 'true');
      else proxy.removeAttribute('aria-disabled');
    };
    if (ctaMo) ctaMo.disconnect();
    ctaMo = new MutationObserver(mirror);
    ctaMo.observe(cta, { attributes: true, attributeFilter: ['disabled'] });
    mirror();
    syncBar();
  }

  if (mqBar) {
    if (mqBar.addEventListener) mqBar.addEventListener('change', syncBar);
    else if (mqBar.addListener) mqBar.addListener(syncBar);
  }
  // hidden while a field has focus (the phone keyboard is up)
  document.addEventListener('focusin', function (e) {
    fieldFocus = isField(e.target);
    syncBar();
  });
  document.addEventListener('focusout', function () {
    setTimeout(function () {
      fieldFocus = isField(document.activeElement);
      syncBar();
    }, 0);
  });

  /* ---------- express buttons: hide "or pay with" if no wallet appears ---------- */
  function setupWallets() {
    var w = $('[data-tic-cp-wallets]');
    if (!w || w.__ticWallets) return;
    w.__ticWallets = true;
    var measure = function () {
      if (!root || isEmptyCart()) return;
      var el = w.querySelector('shopify-accelerated-checkout-cart') || w.firstElementChild;
      var h = el ? el.getBoundingClientRect().height : 0;
      root.classList.toggle('tic-cp--no-wallets', h < 20);
    };
    if ('ResizeObserver' in window) {
      if (walletRo) walletRo.disconnect();
      walletRo = new ResizeObserver(function () {
        if (root && root.classList.contains('tic-cp--no-wallets')) measure();
      });
      var target = w.querySelector('shopify-accelerated-checkout-cart');
      if (target) walletRo.observe(target);
    }
    var later = function () { setTimeout(measure, 4000); };
    if (document.readyState === 'complete') later();
    else window.addEventListener('load', later, { once: true });
  }

  /* ---------- suggestions: the site's scroll reveal (only if below the fold at load) ---------- */
  function armReveal() {
    var list = $('[data-tic-cp-more-list]');
    if (!list || !('IntersectionObserver' in window)) return;
    if (list.getBoundingClientRect().top < window.innerHeight) return;
    list.classList.add('is-armed');
    var o = new IntersectionObserver(function (entries) {
      if (!entries[0] || !entries[0].isIntersecting) return;
      list.classList.add('is-in');
      o.disconnect();
    }, { rootMargin: '0px 0px -10% 0px' });
    o.observe(list);
  }

  /* ---------- 5. safety: the theme's self-reload of <cart-items> ---------- */
  function guardCartItems() {
    var ci = $('cart-items');
    if (ci && !ci.__ticGuarded && typeof ci.cartUpdateUnsubscriber === 'function') {
      try { ci.cartUpdateUnsubscriber(); } catch (err) { /* already gone */ }
      ci.cartUpdateUnsubscriber = function () {};
      ci.__ticGuarded = true;
    }
    if (ci && !ci.__ticFocus && typeof ci.enableLoading === 'function') {
      // cart.js blurs the focused element when a request starts: note which one (see takeBlurred)
      var enableLoading = ci.enableLoading;
      ci.enableLoading = function () {
        var ae = document.activeElement;
        blurred = ae && ae !== document.body ? ae : null;
        return enableLoading.apply(this, arguments);
      };
      ci.__ticFocus = true;
    }
    if (!subscribed && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribed = true;
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (ev && ev.source === 'cart-items') return; // cart.js on this page: already handled
        if (root) refreshAll();
      });
    }
  }

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted || !root) return;
    resetCheckout(); // back from checkout: the button must not stay "busy"
    refreshAll();    // the cart may have changed in another page or tab
  });
  // leaving or hiding the page: an unsaved gift message is sent at once (keepalive)
  window.addEventListener('pagehide', function () { if (noteFlush) noteFlush(); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      if (noteFlush) noteFlush();
    } else if (checkoutBusy) {
      resetCheckout(); // back on the page: the checkout did not leave it
    }
  });

  /* ---------- init ---------- */
  function init() {
    var el = document.querySelector('[data-tic-cp]');
    if (!el || el.__ticCp) return;
    el.__ticCp = true;
    root = el;
    sectionId = root.getAttribute('data-section') || '';
    pending = null;
    held = [];
    stepPress = null;
    blurred = null;
    resetCheckout();

    // one live region for the page: the theme's region keeps its content for cart.js only
    var themeLive = document.getElementById('cart-live-region-text');
    if (themeLive && root.contains(themeLive)) {
      themeLive.removeAttribute('role');
      themeLive.removeAttribute('aria-live');
    }

    root.addEventListener('change', onChangeCapture, true);
    root.addEventListener('click', onClickCapture, true);
    root.addEventListener('click', onUndoClick);
    root.addEventListener('submit', onSubmitCapture, true);
    root.addEventListener('keydown', onKeydown);
    root.addEventListener('input', function (e) {
      if (e.target && e.target.name === 'updates[]') syncMinus(e.target);
    });
    // iOS Safari applies :active (the .96 press) only when a touch listener exists
    root.addEventListener('touchstart', function () {}, { passive: true });

    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('cart-items').then(guardCartItems);
    }
    guardCartItems();
    setupNote();
    setupCheckout();
    setupBar();
    setupWallets();
    armReveal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init); // theme editor re-renders the section
})();
